// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-class path{
    fill:orange;
  }
.custom-class{
    border: 2px dotted blue;
    width: 100px;
    height: 100px;
}


*:focus-visible {
    outline: 2px solid #b91900 !important;
}

.digit-checkbox-container .digit-custom-checkbox-emp:focus-visible{
  outline-offset: 3px;
}

.digit-cursor-pointer .digit-text-input-customIcon{
  position: unset;
}

.digit-cursor-pointer .wrapperSpan{
  position: absolute;
  height: 24px;
  width: 24px;
  top: 0.5rem;
  right: 0.75rem;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,WAAW;EACb;AACF;IACI,uBAAuB;IACvB,YAAY;IACZ,aAAa;AACjB;;;AAGA;IACI,qCAAqC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,cAAc;AAChB","sourcesContent":[".custom-class path{\n    fill:orange;\n  }\n.custom-class{\n    border: 2px dotted blue;\n    width: 100px;\n    height: 100px;\n}\n\n\n*:focus-visible {\n    outline: 2px solid #b91900 !important;\n}\n\n.digit-checkbox-container .digit-custom-checkbox-emp:focus-visible{\n  outline-offset: 3px;\n}\n\n.digit-cursor-pointer .digit-text-input-customIcon{\n  position: unset;\n}\n\n.digit-cursor-pointer .wrapperSpan{\n  position: absolute;\n  height: 24px;\n  width: 24px;\n  top: 0.5rem;\n  right: 0.75rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
